export default __webpack_public_path__ + "static/media/engin.d0608f77.png";